import React, { useState, useEffect } from 'react';
import PdfBackground from '../card/pdfCard/pdfBackground';
const RecentManuals = ({ manuals, selectedId, onSelect }) => {
  const [grouped, setGrouped] = useState({});

  useEffect(() => {
    const groups = manuals.reduce((acc, m) => {
      const sec = m.section?.name || 'Sin sección';
      acc[sec] = acc[sec] || [];
      acc[sec].push(m);
      return acc;
    }, {});
    setGrouped(groups);
  }, [manuals]);

  return (
    <div className="space-y-8">
      {Object.entries(grouped).map(([section, items]) => (
        <div key={section} >
          <h2 className="px-2 mb-2 text-xl font-itcmedium">{section}</h2>
          <div className="flex w-full gap-4 p-2 overflow-hidden overflow-x-auto sm:justify-items-center sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {items.map(m => {
            const isSelected = m.id === selectedId;
            return (
              <button
                key={m.id}
                onClick={() => onSelect(m.id)}
                className={`
                  relative flex-shrink-0 drop-shadow-manual w-[240px] h-[320px] rounded-lg transition cursor-pointer overflow-hidden
                  ${isSelected ? 'border-2 border-blue bg-blue bg-opacity-10 shadow-lg' : 'border border-transparent hover:border-gray'}
                `}
              >
                <div className="absolute inset-0 z-0">
                  <PdfBackground
                    pdfFile={m.file}
                  />
                </div>

                <div
                  className={`
                    absolute inset-0 z-10 w-full h-full
                    ${isSelected ? 'bg-blue bg-opacity-20' : 'bg-black bg-opacity-30'}
                  `}
                />
                
                  <div className='p-2'>
                    <span className="relative z-20 text-center text-white break-words font-itcbold">
                      {m.title}
                    </span>
                  
                  </div>
              </button>
            );
          })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentManuals;